import { animate, style, transition, trigger } from "@angular/animations";
import { Component, Inject, Input } from "@angular/core";
import { environment } from "@environments";
import { DecodedToken } from "@serasa/shared/utils/interfaces/decoded-token.interface";
import { Utils } from "@serasa/shared/utils/utils";
import { Notifications } from "../../interfaces/notification-state.interface";

@Component({
    selector: "pl-notification-panel",
    templateUrl: "./notification-panel.component.html",
    styleUrls: ["./notification-panel.component.scss"],
    animations: [
        trigger('fadeOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('0.5s ease-in', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate('0.5s ease-out', style({ opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class NotificationPanelComponent {
  constructor(@Inject('locationObject') public location: Location) { }

  @Input() notifications?: Notifications[];

  callAccessesAdminApp() {
    const decodeToken: DecodedToken | null = Utils.decodeToken();
    this.location.href = this.mountURL(decodeToken);
  }

  private mountURL(token: DecodedToken | null): string {
    const url = `${environment.accessesAdministration.URL}?param=${token?.param}`;
    return url;
  }
}
